import { useState, useEffect } from 'react';

const useTopRatedCompanies = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTopRatedCompanies = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/company/top-rated-companies`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        // Ensure we always have an array - handle different response structures
        const itemsArray = Array.isArray(data.data) 
          ? data.data 
          : Array.isArray(data.data?.data) 
            ? data.data.data 
            : [];
        setItems(itemsArray); 
      } catch (error) {
        setError(error.message);
        console.error('Error fetching top-rated companies:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopRatedCompanies();
  }, []);

  return { items, loading, error };
};

export default useTopRatedCompanies;
